// string constants
export const START_FILE_EDIT     = 'uiEditing/START_FILE_EDIT';
export const STOP_FILE_EDIT      = 'uiEditing/STOP_FILE_EDIT';
export const STOP_ALL_FILE_EDITS = 'uiEditing/STOP_ALL_FILE_EDITS';

// typed action shapes
export interface StartFileEditAction {
  type: typeof START_FILE_EDIT;
  payload: number; // fileId
}

export interface StopFileEditAction {
  type: typeof STOP_FILE_EDIT;
  payload: number; // fileId
}

export interface StopAllFileEditsAction {
  type: typeof STOP_ALL_FILE_EDITS;
}

export type UiEditingActions =
  | StartFileEditAction
  | StopFileEditAction
  | StopAllFileEditsAction;
